import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';

import { HomeSection } from '#client/components/HomeSection';

import ChatAction from './ChatAction';
import { HelpSectionActions as Actions, HelpSectionActionItem as ActionItem } from './HelpSection.style';

function HelpSection() {
  return (
    <HomeSection
      title={(
        <Text color="primary" size="xl" weight="medium">
          <FormattedMessage id="dashboard.helpSection.title" />
        </Text>
      )}
    >
      <Actions>
        <ActionItem>
          <ChatAction />
        </ActionItem>
      </Actions>
    </HomeSection>
  );
}

export default HelpSection;
